import React from 'react';
import styled from 'styled-components';
import { useWallet } from '../../hooks/useWallet'; // To get disconnect function
import { LogOut, Copy } from 'lucide-react'; // Icons for actions

const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px); // Position below the button with some spacing
  right: 0;
  background-color: #2c2c2e; // Matches button background
  border: 1px solid #3a3a3c; // Matches button border
  border-radius: 8px;
  padding: 8px;
  z-index: 1000;
  min-width: 200px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const DropdownItem = styled.button`
  background: none;
  border: none;
  color: #e0e0e0;
  padding: 10px 12px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  border-radius: 4px;

  &:hover {
    background-color: #3a3a3c;
  }

  svg {
    margin-right: 10px;
  }
`;

const AddressDisplay = styled.div`
  padding: 10px 12px;
  color: #a0a0a0; // Dimmer color for the address display
  font-size: 13px;
  border-bottom: 1px solid #3a3a3c;
  margin-bottom: 8px;
  word-break: break-all; // Ensure long addresses don't break layout
`;

interface WalletDropdownProps {
  address: string;
  onClose: () => void;
}

export const WalletDropdown: React.FC<WalletDropdownProps> = ({ address, onClose }) => {
  const { disconnect } = useWallet();

  const handleDisconnect = () => {
    disconnect();
    onClose(); // Close the dropdown after disconnecting
  };

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(address)
      .then(() => {
        // Optional: Show a temporary success message or toast
        console.log('Address copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy address: ', err);
      });
    onClose(); // Close dropdown after attempting copy
  };

  const formatAddress = (addr: string) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  return (
    <DropdownContainer>
      <AddressDisplay title={address}>{formatAddress(address)}</AddressDisplay>
      <DropdownItem onClick={handleCopyAddress}>
        <Copy size={16} />
        Copy Address
      </DropdownItem>
      <DropdownItem onClick={handleDisconnect}>
        <LogOut size={16} />
        Disconnect
      </DropdownItem>
      {/* Future options can be added here e.g., View on Explorer */}
    </DropdownContainer>
  );
}; 